import React, { FC, useState } from 'react';
import { Button } from '../../../../Partials/Button';
import { NoteForm } from './NoteForm';
import { InsuranceDoctorNoteDto } from '@apiModels/Insurance/InsuranceDoctorNoteDto.csharp';
import { StreamLineIcon } from '../../../../../SvgIcon/StreamLineIcon';
import { useInsuranceLabels } from '../../../../Utils/Context/labelsContext';

interface SingleNoteItemProps {
  note: InsuranceDoctorNoteDto;
  onEditNoteSubmit: (noteId: string, noteText: string, cb: (status: 'error' | 'success') => void) => void;
  onDeleteNote: (noteId: string, cb: (status: 'error' | 'success') => void) => void;
}

export const SingleNoteItem: FC<SingleNoteItemProps> = (props) => {
  const { note, onEditNoteSubmit, onDeleteNote } = props;
  const [isEditModalOpened, setIsEditModalOpened] = useState<boolean>(false);
  const {
    buttons,
  } = useInsuranceLabels();
  return (
    <>
      <li className="singleNoteItem">
        <div className="singleNoteItem__contentWrapper">
          <span className="singleNoteItem__note">{note.text}</span>
        </div>
        <Button
          className="singleNoteItem__button"
          type="solid"
          size="medium"
          tier="secondary"
          onClick={() => setIsEditModalOpened(true)}
          aria-haspopup
          aria-expanded={isEditModalOpened}
        >
          <span className="singleNoteItem__label">
            <StreamLineIcon
              iconName="s-arrow-right-dash"
              className="singleNoteItem__icon"
            />
            <span>
              {buttons.showNoteDetailsButtonLabel}
            </span>
          </span>
        </Button>
      </li>
      {isEditModalOpened && (
        <NoteForm
          type="editNote"
          onSubmit={onEditNoteSubmit}
          onDeleteNote={(cb) => onDeleteNote(note.id, cb)}
          onClose={() => setIsEditModalOpened(false)}
          note={note}
        />
      )}
    </>
  );
};
